
import Vue, { CreateElement } from "vue"
import path from "path"
import { CustomRouteConfig } from "@/types/route"
import { isExternal } from "@/utils/validate"

export default Vue.extend({
    functional: true,
    props: {
        item: Object,
        basePath: String,
        store: Object
    },
    render(h: CreateElement, ctx: any) {
        const { item, basePath } = ctx.props as {
            item: CustomRouteConfig
            basePath: string
        }

        let onlyOneChild: any = null

        function hasOneShowingChild(children: any[] = [], parent: any) {
            const showingChildren = children.filter(item => {
                if (item.hidden) {
                    return false
                } else {
                    onlyOneChild = item
                    return true
                }
            })
            if (showingChildren.length === 1) {
                return true
            }

            if (showingChildren.length === 0) {
                onlyOneChild = {
                    ...parent,
                    path: "",
                    noShowingChildren: true
                }
                return true
            }
            return false
        }

        function resolvePath(routePath: string) {
            let ret
            if (isExternal(routePath)) {
                ret = routePath
            } else if (isExternal(basePath)) {
                ret = basePath
            } else {
                ret = path.resolve(basePath, routePath)
            }
            return ret
        }

        return hasOneShowingChild(item.children, item) &&
            (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
            !item.alwaysShow &&
            onlyOneChild.component ? (
            <a-menu-item key={resolvePath(onlyOneChild.path)}>
                <app-link to={resolvePath(onlyOneChild.path)}>
                    <menu-item
                        icon={
                            (onlyOneChild.meta && onlyOneChild.meta.icon) ||
                            (item.meta && item.meta.icon)
                        }
                        title={onlyOneChild.meta && onlyOneChild.meta.title}
                        icon-type={item.meta && item.meta.iconType}
                    />
                </app-link>
            </a-menu-item>
        ) : (
            <a-sub-menu
                key={resolvePath(item.path)}
                scopedSlots={{
                    title: () => {
                        return (
                            <menu-item
                                icon={item.meta && item.meta.icon}
                                title={item.meta.title}
                                icon-type={item.meta && item.meta.iconType}
                            />
                        )
                    }
                }}
            >
                {item.children
                    .filter((route: CustomRouteConfig) => !route.hidden)
                    .map(child => {
                        return (
                            <sidebar-item
                                key={resolvePath(child.path)}
                                is-nest={true}
                                item={child}
                                base-path={resolvePath(child.path)}
                                class="nest-menu"
                            />
                        )
                    })}
            </a-sub-menu>
        )
    }
} as any)
